import React from 'react';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import RendererComponent from './RendererComponent.tsx';
import type { ReactElement } from 'react';
import type { ADNode } from '@atlaskit/editor-common/utils/validator';
import type { AnnotationProviders } from '@atlaskit/editor-common/types/annotation';
import type { RendererAppearance, RendererContentMode } from '@atlaskit/renderer/types';
import type { ContentTypeType } from '../../actions/editor-action-types.ts';

export type QueryProps = {
	id?: string;
	className?: string;
	style?: object;
	adf: ADNode | null;
	objectId: string;
	contentType?: ContentTypeType;
	spaceKey?: string;
	allowInlineComments?: boolean;
	allowHighlightActions?: boolean;
	appearance?: RendererAppearance;
	contentMode?: RendererContentMode;
	renderWhenReady?: () => ReactElement;
	ignoreHeadingAnchorLinksFeatureFlag?: boolean;
	showTemplateVariablesInPreview?: boolean;
	showTemplateInputInPreview?: boolean;
	onComplete?: (stats: any) => void;
	// Forwarded to the Atlaskit renderer's `onRendered` lifecycle callback, which fires (after
	// paint) on every render pass regardless of analytics sampling. Used to reliably release the
	// RendererTTIMarker UFO load hold instead of the sampled `renderer rendered` analytics event.
	onRendered?: () => void;
	getHash?: () => string;
	allowPlaceholderText?: boolean;
	isPreviewMode?: boolean;
};

export type ExternalProps = QueryProps & {
	accountId: string | null;
	cloudId: string;
	environment: string;
	allowStickyHeaders?: boolean;
	allowAnnotations?: boolean;
	annotationProvider?: AnnotationProviders;
	UNSTABLE_allowTableAlignment?: boolean;
	UNSTABLE_allowTableResizing?: boolean;
};

export default (props: QueryProps): React.JSX.Element => {
	const { userId, cloudId, environment } = useSessionData();
	return (
		<RendererComponent {...props} accountId={userId} cloudId={cloudId} environment={environment} />
	);
};
